var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 6.5H8c-1.457 0-2.398.003-3.092.096-.65.088-.854.23-.969.343-.114.115-.255.318-.343.97C3.503 8.601 3.5 9.542 3.5 11c0 1.457.003 2.398.096 3.092.088.65.23.854.343.969.115.114.318.255.97.342.693.094 1.634.097 3.091.097h5c1.457 0 2.398-.003 3.092-.097.65-.087.855-.228.969-.342.114-.114.255-.318.343-.97.093-.693.096-1.634.096-3.091 0-1.457-.003-2.398-.096-3.092-.088-.65-.23-.854-.343-.969-.114-.114-.318-.255-.97-.343C15.399 6.503 14.458 6.5 13 6.5ZM2.879 5.879C2 6.757 2 8.172 2 11c0 2.828 0 4.243.879 5.121C3.757 17 5.172 17 8 17h5c2.828 0 4.243 0 5.121-.879C19 15.243 19 13.828 19 11c0-2.828 0-4.243-.879-5.121C17.243 5 15.828 5 13 5H8c-2.828 0-4.243 0-5.121.879Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.591 9.41c-.308-.31-.755-.498-1.664-.587l.147-1.493c1.04.102 1.906.347 2.578 1.018.602.602.86 1.36.982 2.26.116.867.116 1.97.116 3.337v.11c0 1.367 0 2.47-.116 3.337-.121.9-.38 1.658-.982 2.26-.602.602-1.36.86-2.26.982-.867.116-1.97.116-3.337.116h-5.11c-1.367 0-2.47 0-3.337-.116-.9-.122-1.657-.38-2.26-.982-.671-.672-.916-1.538-1.018-2.579l1.493-.146c.09.909.278 1.356.586 1.664.277.277.666.457 1.4.556.755.102 1.756.103 3.191.103h5c1.436 0 2.437-.002 3.192-.103.734-.099 1.122-.28 1.4-.556.276-.277.457-.665.555-1.4.102-.754.103-1.755.103-3.19 0-1.436-.001-2.438-.103-3.193-.098-.734-.279-1.122-.556-1.399Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 9.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM7.25 11a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM16 13.75a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75Zm-11 0a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.4ca497c0fcaa06cb61b11799c36af5e4.svg";
export { ForwardRef as ReactComponent };